/*! @pentacode/ui v0.1.0 */
//#region src/elements/table/table.types.ts
function e() {
	return (e) => e;
}
//#endregion
export { e as columnDef };

//# sourceMappingURL=table.types.js.map